import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { getServerDate } from '../api/auth.api';
import { IGetServerDate } from '../models/auth.model';

interface IServerDateState {
  serverDate: string;
  isLoading: boolean;
  error?: AxiosError | string;
}

const initialState: IServerDateState = {
  serverDate: '',
  isLoading: false,
};

const serverDateSlicer = createSlice({
  name: 'serverDate',
  initialState,
  reducers: {
    getServerDateStart: (state: IServerDateState) => {
      state.serverDate = '';
      state.isLoading = true;
      state.error = undefined;
    },
    getServerDateSuccess: (state: IServerDateState, action: PayloadAction<IGetServerDate>) => {
      state.serverDate = action.payload.data?.serverDate;
      state.isLoading = false;
      state.error = undefined;
    },
    getServerDateFailure: (state: IServerDateState, action: PayloadAction<AxiosError | string>) => {
      state.serverDate = '';
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getServerDateStart,
  getServerDateSuccess,
  getServerDateFailure,
} = serverDateSlicer.actions;

export default serverDateSlicer.reducer;

export const doGetServerDate = (): any => async (dispatch: any) => {
  try {
    dispatch(getServerDateStart());
    const response = await getServerDate();
    dispatch(getServerDateSuccess(response.data));
    return response;
  } catch (e: any) {
    dispatch(getServerDateFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};
